var _excluded = ["append", "children", "className", "clearable", "disabled", "focused", "hint", "surfaceRef", "label", "labelFor", "labelId", "onClear", "onClickLabel", "prepend", "readOnly", "validationState", "large", "medium", "small"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
import AIcon from "../AIcon";
import AFieldBase from "../AFieldBase";
import { keyCodes } from "../../utils/helpers";
import "./AInputBase.scss";
var AInputBase = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var append = _ref.append,
    children = _ref.children,
    propsClassName = _ref.className,
    clearable = _ref.clearable,
    disabled = _ref.disabled,
    focused = _ref.focused,
    hint = _ref.hint,
    surfaceRef = _ref.surfaceRef,
    label = _ref.label,
    labelFor = _ref.labelFor,
    labelId = _ref.labelId,
    onClear = _ref.onClear,
    onClickLabel = _ref.onClickLabel,
    prepend = _ref.prepend,
    readOnly = _ref.readOnly,
    _ref$validationState = _ref.validationState,
    validationState = _ref$validationState === void 0 ? "default" : _ref$validationState,
    large = _ref.large,
    medium = _ref.medium,
    small = _ref.small,
    rest = _objectWithoutProperties(_ref, _excluded);
  var className = "a-input-base";
  if (prepend) {
    className += " a-input-base--prepend";
  }
  if (append) {
    className += " a-input-base--append";
  }
  if (clearable) {
    className += " a-input-base--clearable";
  }
  if (focused) {
    className += " a-input-base--focused";
  }
  if (disabled) {
    className += " a-input-base--disabled";
  }
  if (readOnly) {
    className += " a-input-base--readonly";
  }
  if (large) {
    className += " a-input-base--large";
  } else if (medium) {
    className += " a-input-base--medium";
  } else if (small) {
    className += " a-input-base--small";
  }
  if (validationState !== "default") {
    className += " a-input-base--".concat(validationState);
  }
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  return /*#__PURE__*/React.createElement(AFieldBase, _extends({}, rest, {
    ref: ref,
    className: className,
    label: label,
    labelId: labelId,
    labelFor: labelFor,
    onClickLabel: onClickLabel,
    hint: hint,
    validationState: validationState
  }), /*#__PURE__*/React.createElement("div", {
    ref: surfaceRef,
    className: "a-input-base__surface"
  }, prepend && /*#__PURE__*/React.createElement("div", {
    className: "a-input-base__prepend"
  }, prepend), /*#__PURE__*/React.createElement("div", {
    className: "a-input-base__control"
  }, children), (append || clearable) && /*#__PURE__*/React.createElement("div", {
    className: "a-input-base__append"
  }, clearable && !readOnly && /*#__PURE__*/React.createElement(AIcon, {
    tabIndex: 0,
    role: "button",
    className: "a-input-base__clear",
    size: 16,
    onClick: onClear,
    onKeyDown: function onKeyDown(e) {
      if ([keyCodes.enter, keyCodes.space].includes(e.keyCode)) {
        e.preventDefault();
        onClear(e);
      }
    }
  }, "close"), append)));
});
AInputBase.propTypes = {
  /**
   * Append content to the control.
   */
  append: PropTypes.node,
  /**
   * Toggles whether the clear button is rendered.
   */
  clearable: PropTypes.bool,
  /**
   * Toggles the `disabled` state.
   */
  disabled: PropTypes.bool,
  /**
   * Toggles the `focused` state.
   */
  focused: PropTypes.bool,
  /**
   * Sets the hint content.
   */
  hint: PropTypes.node,
  /**
   * Sets the label content.
   */
  label: PropTypes.node,
  /**
   * The label's `for` attribute.
   */
  labelFor: PropTypes.string,
  /**
   * The label's `id` attribute.
   */
  labelId: PropTypes.string,
  /**
   * Handles the `clear` event.
   */
  onClear: PropTypes.func,
  /**
   * Handles the label's `click` event.
   */
  onClickLabel: PropTypes.func,
  /**
   * Prepends content to the control.
   */
  prepend: PropTypes.node,
  /**
   * Toggles the `readOnly` state.
   */
  readOnly: PropTypes.bool,
  /**
   * Sets the `ref` of the surface element.
   */
  surfaceRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),
  /**
   * Applies a validation state.
   */
  validationState: PropTypes.oneOf(["default", "warning", "danger"]),
  /**
   * Sets widget size to magnetic large
   */
  large: PropTypes.bool,
  /**
   * Sets widget size to magnetic medium
   */
  medium: PropTypes.bool,
  /**
   * Sets widget size to magnetic small (default)
   */
  small: PropTypes.bool
};
AInputBase.displayName = "AInputBase";
export default AInputBase;